__turbopack_context__.v({
  "buttons": "section-news-module__LoKxQW__buttons",
  "copyright": "section-news-module__LoKxQW__copyright",
  "epfl": "section-news-module__LoKxQW__epfl",
  "epflNews": "section-news-module__LoKxQW__epflNews",
  "label": "section-news-module__LoKxQW__label",
  "news": "section-news-module__LoKxQW__news",
  "separator": "section-news-module__LoKxQW__separator",
});
